<avi-card class="tech-support-page-card">
    <avi-card_header class="tech-support-page-card__header">
        <cds-icon
            shape="view-list"
            size="18"
            class="tech-support-page-card__view-list"
        ></cds-icon>
        {{ l10nKeys.inProgressLabel | vtranslate }}
    </avi-card_header>
    <avi-card_body>
        <ng-container *ngIf="packagesInProgress.length > 0; else noPackageInprogress">
            <div 
                *ngFor="let pkg of packagesInProgress"
                class="tech-support-page-card__package"
            >
                <div 
                    *ngIf="pkg.techsupport_readiness?.progress < 100"
                    class="tech-support-page-card__loader-container"
                >
                    <clr-spinner [clrSmall]="true"></clr-spinner>
                </div>
                <div class="tech-support-page-card__progress-details">
                    <div class="tech-support-page-card__detail-row">
                        <strong>{{ pkg.level }}&nbsp;</strong>
                        <span>{{ pkg.name }}</span>
                    </div>
                    <div class="tech-support-page-card__detail-row">
                        <avi-progress-bar
                            *ngIf="pkg.techsupport_readiness?.progress === 100"
                            [percentage]="pkg.progress"
                            [hidePercentage]="true"
                            [small]="true"
                        ></avi-progress-bar>
                    </div>
                    <div class="tech-support-page-card__status-row">
                        <div>
                            <span *ngIf="pkg.techsupport_readiness?.progress < 100">
                                {{ l10nKeys.runningPreChecksLabel | vtranslate }}
                            </span>
                            <span *ngIf="pkg.techsupport_readiness?.progress === 100">
                                {{ l10nKeys.preparingPackageLabel | vtranslate }}
                            </span>
                        </div>
                        <div>
                            {{ pkg.progress ? pkg.progress + '%' : '0%' }}
                        </div>
                    </div>
                </div>
                <avi-dropdown-button
                    [actions]="packageActions"
                    [position]="buttonDropdownPosition"
                    size="sm"
                    [hideCaret]="true"
                    [useIcon]="true"
                    id="sel-package-action-icon"
                    class="tech-support-page-card__package-action"
                    [context]="pkg"
                >
                    <cds-icon shape="ellipsis-vertical" size="sm"></cds-icon>
                </avi-dropdown-button>
            </div>
        </ng-container>
        <ng-template #noPackageInprogress>
            <div class="tech-support-page-card__no-progress">
                {{ l10nKeys.nothingInProgressLabel | vtranslate }}
            </div>
        </ng-template>
    </avi-card_body>
</avi-card>

<tech-support-wizard
    *ngIf="openProgressWizard"
    (onClose)="onClose()"
    [selectedPackage]="selectedPackage"
></tech-support-wizard>
